import onDOMContentLoaded from '../utils/on-dom-content-loaded';

const handleSocialClick = (e) => {
  e.preventDefault();
  window.open(e.currentTarget.href, 'window', 'width=500,height=500');
};

const initSocialShareClick = () => {
  document.querySelectorAll('.js-social-share-button').forEach((button) => {
    button.addEventListener('click', (e) => handleSocialClick(e));
    button.addEventListener('touch', (e) => handleSocialClick(e));
  });
};

onDOMContentLoaded().then(() => initSocialShareClick());
